import withCachedUser from '../../components/higher-order/withCachedUser';
import CommentItem from '../../components/post/CommentItem';

const CachedAuthorCommentItem = withCachedUser({
  uidPropName: 'authorUid',
  dataPropName: 'author',
})(CommentItem);

export default CachedAuthorCommentItem;
